import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class RoleQueryCriteriaClass extends BaseCriteriaModel {
  namespace?: Optional<string> = Optional.empty();
  role_type?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
}

export class RoleCriteriaModelQuery {
  query = '';

  constructor(roleCriteriaModel: RoleQueryCriteriaClass) {

    if (!roleCriteriaModel) {
      return;
    }

    this.query += roleCriteriaModel.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += roleCriteriaModel.role_type.filter(x => x !== '').map(x => '&role_type=' + x).orElse('');
    this.query += roleCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');

    this.query += '&status=' + roleCriteriaModel.status;
    this.query += '&orderBy=' + roleCriteriaModel.orderBy;
    this.query += '&order=' + roleCriteriaModel.order;
    this.query += '&offset=' + roleCriteriaModel.offset + '&limit=' + roleCriteriaModel.limit;
  }
}
